// extracted by mini-css-extract-plugin
export var carousalWrapper = "corousel-module--carousalWrapper--5jBZs";
export var expandImg = "corousel-module--expandImg--iQCyl";